export interface OpportunityItem {
  emoji: string
  title: string
  body: string
  icon: 'tree' | 'gift' | 'store'
}

export const opportunityItems: OpportunityItem[] = [
  {
    emoji: '🎄',
    icon: 'tree',
    title: 'Decoración personalizada',
    body: 'Transforma tu árbol con piezas hechas por ti.',
  },
  {
    emoji: '🎁',
    icon: 'gift',
    title: 'Regalos únicos',
    body: 'Crea recuerdos especiales para familiares y amigos.',
  },
  {
    emoji: '💰',
    icon: 'store',
    title: 'Emprendimiento de temporada',
    body: 'Aprovecha la alta demanda navideña para vender tus creaciones.',
  },
]
